/* import __COLOCATED_TEMPLATE__ from './rule.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();